<template>
  <div class="stay-condition">
    <div v-if="icon === 'dot'" class="dot mr-2"><div></div></div>
    <i v-else :class="classIcon" class="mr-2 xs" />
    <span :class="`stay-condition__text text-${color}`" v-html="label"></span>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String // possible values -> tick, dot
    },
    color: {
      type: String // possible values -> green, black
    },
    label: {
      type: String // possible values -> Breakfast and dinner included
    },
    classIcon: {
      type: String // possible values -> class icon
    }
  }
}
</script>

<style lang="scss" scoped>
.stay-condition {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  padding: 0 0.7rem;
  &__text {
    font-size: 1.4rem !important;
  }
}
</style>
